import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type {
  OrganizationStats,
  PlatformOverviewResponse,
  SuspendOrgResponse,
  DeleteOrgResponse,
  BulkUnsuspendOrgResponse,
  OrganizationCreate,
  OrganizationUpdate,
  ProvisionOrgResponse,
} from '../types/api.types'

export const platformOrgService = {
  async getOverview(): Promise<PlatformOverviewResponse> {
    const { data } = await axiosInstance.get<PlatformOverviewResponse>(API_ENDPOINTS.PLATFORM_OVERVIEW)
    return data
  },

  async getAll(params?: { organization_type?: string; is_active?: boolean }): Promise<OrganizationStats[]> {
    const q = new URLSearchParams()
    if (params?.organization_type) q.set('organization_type', params.organization_type)
    if (params?.is_active !== undefined) q.set('is_active', String(params.is_active))
    const qs = q.toString() ? `?${q.toString()}` : ''
    const { data } = await axiosInstance.get<OrganizationStats[]>(`${API_ENDPOINTS.PLATFORM_ORGS}${qs}`)
    return data
  },

  async getById(orgId: number): Promise<OrganizationStats> {
    const { data } = await axiosInstance.get<OrganizationStats>(API_ENDPOINTS.PLATFORM_ORG_BY_ID(orgId))
    return data
  },

  async create(payload: OrganizationCreate): Promise<OrganizationStats> {
    const { data } = await axiosInstance.post<OrganizationStats>(API_ENDPOINTS.PLATFORM_ORGS, payload)
    return data
  },

  async update(orgId: number, payload: OrganizationUpdate): Promise<OrganizationStats> {
    const { data } = await axiosInstance.patch<OrganizationStats>(
      API_ENDPOINTS.PLATFORM_ORG_BY_ID(orgId),
      payload,
    )
    return data
  },

  async delete(orgId: number): Promise<DeleteOrgResponse> {
    const { data } = await axiosInstance.delete<DeleteOrgResponse>(
      API_ENDPOINTS.PLATFORM_ORG_BY_ID(orgId),
    )
    return data
  },

  async suspend(orgId: number): Promise<SuspendOrgResponse> {
    const { data } = await axiosInstance.patch<SuspendOrgResponse>(
      API_ENDPOINTS.PLATFORM_ORG_SUSPEND(orgId),
    )
    return data
  },

  async unsuspend(orgId: number): Promise<SuspendOrgResponse> {
    const { data } = await axiosInstance.patch<SuspendOrgResponse>(
      API_ENDPOINTS.PLATFORM_ORG_UNSUSPEND(orgId),
    )
    return data
  },

  async provision(formData: FormData): Promise<ProvisionOrgResponse> {
    const { data } = await axiosInstance.post<ProvisionOrgResponse>(
      API_ENDPOINTS.ORGS_PROVISION,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    return data
  },

  async uploadLogo(orgId: number, file: File): Promise<OrganizationStats> {
    const form = new FormData()
    form.append('logo', file)
    const { data } = await axiosInstance.patch<OrganizationStats>(
      API_ENDPOINTS.PLATFORM_ORG_LOGO(orgId),
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    return data
  },

  async bulkUnsuspend(): Promise<BulkUnsuspendOrgResponse> {
    const { data } = await axiosInstance.post<BulkUnsuspendOrgResponse>(
      API_ENDPOINTS.PLATFORM_ORGS_BULK_UNSUSPEND,
      null,
    )
    return data
  },
}
